/**
 * NewQuotationPage — form to create a new quotation.
 *
 * On success, navigates to the quotation detail page.
 */

import { useNavigate } from 'react-router-dom'
import { useCreateQuotation } from '@/hooks/useQuotations'
import { QuotationForm } from '@/components/quotations/QuotationForm'
import type { CreateQuotationDTO } from '@1klick/types'

export function NewQuotationPage() {
  const navigate = useNavigate()
  const createMutation = useCreateQuotation()

  const handleSubmit = (data: CreateQuotationDTO) => {
    createMutation.mutate(data, {
      onSuccess: (quotation) => {
        navigate(`/quotations/${quotation.id}`)
      },
    })
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Nueva cotizacion</h1>
        <p className="mt-1 text-sm text-gray-500">
          Crea una nueva cotizacion para un prospecto. Se guardara como borrador.
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <QuotationForm
          onSubmit={handleSubmit}
          isSubmitting={createMutation.isPending}
        />

        {createMutation.isError && (
          <div className="mt-4 rounded-md bg-red-50 p-4">
            <p className="text-sm text-red-700">
              Error al crear la cotizacion: {createMutation.error?.message}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
